import { render, staticRenderFns } from "./CustomReportsPage.vue?vue&type=template&id=35369f5c&scoped=true&"
import script from "./CustomReportsPage.vue?vue&type=script&lang=js&"
export * from "./CustomReportsPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportsPage.vue?vue&type=style&index=0&id=35369f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35369f5c",
  null
  
)

export default component.exports